/**
 * Delegated handler for all `.klaviyo-hero-form` signup forms (hero, footer, etc.).
 */
(function () {
  if (window.__klaviyoSignupFormsBound) return;
  window.__klaviyoSignupFormsBound = true;

  function getMessageEl(form) {
    var wrap = form.closest('.klaviyo-signup-wrap') || form.closest('.hero-signup__form-block');
    if (!wrap) return null;
    return wrap.querySelector('.hero-signup__form-message');
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('klaviyo-hero-form')) return;

      e.preventDefault();

      var input = form.querySelector('input[type="email"]');
      var message = getMessageEl(form);
      if (!input || !message) return;

      var email = input.value.trim();
      var listId = form.getAttribute('data-klaviyo-list-id');
      var companyId = form.getAttribute('data-klaviyo-company-id');
      var successRaw = form.getAttribute('data-success-message');
      var submitLabel = form.getAttribute('data-submit-label') || 'JOIN';
      var customSource = form.getAttribute('data-custom-source') || 'Newsletter signup';

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        message.textContent =
          (window.validationStrings && window.validationStrings.invalidEmail) ||
          'Please enter a valid email address.';
        message.className = 'hero-signup__form-message is-error';
        return;
      }

      if (!listId || !companyId) {
        message.textContent = 'Signup is not configured. Please set Klaviyo Company ID and List ID.';
        message.className = 'hero-signup__form-message is-error';
        return;
      }

      var submitBtn = form.querySelector('.hero-signup__submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = '...';
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: customSource,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId,
                },
              },
            },
          },
        }),
      })
        .then(function (response) {
          if (response.ok || response.status === 202) {
            message.textContent = successRaw || "You're subscribed.";
            message.className = 'hero-signup__form-message is-success';
            input.value = '';
          } else {
            throw new Error('Subscription failed');
          }
        })
        .catch(function () {
          message.textContent = 'Something went wrong. Please try again.';
          message.className = 'hero-signup__form-message is-error';
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
        });
    },
    true
  );
})();
